import { z } from 'zod';
import { bindInputMaker } from '../util.make-input.js';

const makeInput = bindInputMaker();
const onImageFractionInput = makeInput({
  entry: {
    schema: z.object({
      type: z.literal("on-image-fraction").default("on-image-fraction"),
      number: z.string().default(""),
      numerator: z.string().default(""),
      denominator: z.string().default("")
    }),
    shouldValidate: node => !!node.validation.correctAnswers.length,
    validate: (node, entry) => node.validation.correctAnswers.some(correctAnswer => (node.styling.hideNumber || correctAnswer.number?.trim() === entry.number.trim()) && correctAnswer.numerator.trim() === entry.numerator.trim() && correctAnswer.denominator.trim() === entry.denominator.trim()),
    parseLegacyDetailItem: (item, context) => {
      if (["WriteAnswers"].includes(context.relatedTask.taskType) && ["OnImage"].includes(context.relatedTask.answerType ?? "") && item && typeof item === "object" && "numerator" in item && "denominator" in item && "number" in item) {
        return [context.relatedInput?.id ?? `${context.relatedTask.id}-${context.indexInDetails}`, {
          type: "on-image-fraction",
          number: item.number,
          denominator: item.denominator,
          numerator: item.numerator
        }];
      }
    }
  },
  schema: z.object({
    type: z.literal("Fraction"),
    style: z.object({
      hideNumber: z.boolean().default(false)
    }).default({
      hideNumber: false
    }),
    placement: z.object({
      x: z.number(),
      y: z.number()
    }),
    correctAnswer: z.array(z.object({
      number: z.string().nullable().default(null),
      numerator: z.string().default(""),
      denominator: z.string().default("")
    }))
  }),
  postprocessSchemaInput: (input, context) => {
    return {
      id: `${context.taskId}-${context.index}`,
      nodeType: "on-image-fraction-input",
      placement: input.placement,
      styling: input.style,
      validation: {
        correctAnswers: input.correctAnswer
      }
    };
  }
});

export { onImageFractionInput };
//# sourceMappingURL=input.fraction.js.map
